import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';


export interface HealthCloudAccessToken {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
}

export interface HealthDetail {
  patientId: string;
  legalReferenceNumber: string;
  healthScoreId: string;
  dateCalculated: string;
  healthScore: number;
  benchmark: any;
  hasWearableDevices: boolean;
  totalDataPoints: number;
  conditionsWithMatchedMedication: number;
  conditionsWithoutMedication: number;
  scoreChangedOrHasNudges: any;
  biometricDataPoints: BiometricDataPoint[];
  healthScoreNudges: HealthNudge[];
  nextDailyRefresh: any;
  nextWeeklyRefresh: any;
  nextMonthlyRefresh: any;
  minorDisclaimerMessage: any;
}

export interface BiometricDataPoint {
  biometric: string;
  score: number;
  impactOrder: number;
  contributingPoints: number;
  resultDate: string;
  riskType?: string;
  ruleText?: string;
  riskTypeDescription?: string;
}

export interface HealthNudge {
  name: string;
  message: string;
  nudgeType: string;
  mediaArticleId: any;
}


@Injectable({
  providedIn: 'root'
})
export class AlulaHealthCloudService {

  constructor(private httpClient: HttpClient) {
  }

  getAccessTokenFromHealthCloudAPI(): Observable<HealthCloudAccessToken> {
    const body = {
      clientId: 'ca360b3c-243d-4d0f-a146-6377dc991e1f',
      secret: '8tR8Q~dUZn-LnvoMOKXoXBYZ51P6_B4BpWxYVbo6'
    };

    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      responseType: 'json',
    });

    return this.httpClient.post<HealthCloudAccessToken>('https://api.alula.health/health/za/healthcloud/Token/AccessToken', body, {headers: httpHeaders});
  }

  getScoreDetailsFromHealthCloudAPI(insuredPersonId: string, headers: HttpHeaders): Observable<HealthDetail> {
    return this.httpClient.get<HealthDetail>(`https://api.alula.health/health/za/healthcloud/HealthScore/LastScore/${insuredPersonId}`, {headers});
  }
}
